module.exports = __webpack_public_path__ + "static/media/valera.14cc27ae.png";